// NOTE: hardcoded mapped with
// https://github.com/saucelabs/user-service/blob/develop/settings/common.py#L157
/* eslint import/prefer-default-export: 0 */
export const DEFAULT_LIMIT = 20;
